import { isIos } from '../helpers/os';

export const appDep = isIos;
